function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Log from '@deephaven/log';
var log = Log.module('DownloadServiceWorkerUtils');
class DownloadServiceWorkerUtils {
  /**
   * Register the download service worker at the specified URL
   * Will unregister any existing service worker if register is called multiple times
   * @param url The URL of the service worker file
   */
  static register(url) {
    if (DownloadServiceWorkerUtils.serviceWorkerRegistration) {
      DownloadServiceWorkerUtils.unregisterSW();
    }
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.register(url).then(reg => {
        reg.update();
        DownloadServiceWorkerUtils.serviceWorkerRegistration = reg;
        log.info('Registering service worker on ', url, reg);
      }).catch(err => {
        log.error('Failed to register service worker', err);
      });
    } else {
      log.info('Service worker is not supported.');
    }
  }
  static getServiceWorker() {
    return _asyncToGenerator(function* () {
      if ('serviceWorker' in navigator) {
        var swReg = DownloadServiceWorkerUtils.serviceWorkerRegistration;
        if (swReg && swReg.active) {
          log.info('Download service worker is active.');
          return swReg.active;
        }
        throw new Error('Can not find download service worker.');
      }
      throw new Error('Download service worker is not available.');
    })();
  }
  static unregisterSW() {
    var _DownloadServiceWorke;
    (_DownloadServiceWorke = DownloadServiceWorkerUtils.serviceWorkerRegistration) === null || _DownloadServiceWorke === void 0 || _DownloadServiceWorke.unregister();
  }
}
_defineProperty(DownloadServiceWorkerUtils, "serviceWorkerRegistration", null);
export default DownloadServiceWorkerUtils;
//# sourceMappingURL=DownloadServiceWorkerUtils.js.map